import { useEffect, useId, useState } from "react";
import { Modal, Button, FormField, Alert } from "../../ui";

const HTTP_URL = /^https?:\/\/\S+$/i;

export default function EditWebhookModal({ webhook, isOpen, onClose, onSubmit }) {
  const [webhookUrl, setWebhookUrl] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const fieldId = useId();
  const formId = `${fieldId}-form`;

  useEffect(() => {
    setWebhookUrl(webhook || "");
    setError("");
  }, [webhook, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedUrl = webhookUrl.trim();
    if (!HTTP_URL.test(trimmedUrl)) {
      return setError("Enter a valid URL starting with http:// or https://");
    }

    setError("");
    setLoading(true);

    try {
      await onSubmit({ webhookUrl: trimmedUrl });
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Something went wrong");
    }

    setLoading(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Edit Webhook URL" size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button type="submit" form={formId} loading={loading}>Update</Button>
        </>
      }
    >
      {error && (
        <Alert variant="danger" className="mb-4" onDismiss={() => setError("")}>{error}</Alert>
      )}

      <form id={formId} onSubmit={handleSubmit} noValidate>
        <FormField
          label="Webhook URL"
          htmlFor={`${fieldId}-url`}
          hint="We POST event payloads to this endpoint."
          required
        >
          <input
            id={`${fieldId}-url`}
            type="url"
            className="form-control"
            placeholder="https://example.com/webhooks/cashafrica"
            value={webhookUrl}
            onChange={(e) => setWebhookUrl(e.target.value)}
            required
          />
        </FormField>
      </form>
    </Modal>
  );
}
